function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  id: "Ellipse_36",
  "data-name": "Ellipse 36",
  cx: 3.009,
  cy: 3.009,
  r: 3.009,
  transform: "translate(5.844)",
  fill: "#fff"
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  id: "Ellipse_37",
  "data-name": "Ellipse 37",
  cx: 1.902,
  cy: 1.902,
  r: 1.902,
  transform: "translate(13.039 2.214)",
  fill: "#fff"
});

var _ref4 =
/*#__PURE__*/
React.createElement("circle", {
  id: "Ellipse_38",
  "data-name": "Ellipse 38",
  cx: 1.902,
  cy: 1.902,
  r: 1.902,
  transform: "translate(0.863 2.214)",
  fill: "#fff"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_305",
  "data-name": "Path 305",
  d: "M4.641,16.039a3.076,3.076,0,0,0-2.293-.532A2.344,2.344,0,0,0,0,17.841v3.777a1.016,1.016,0,0,0,1.017,1.013c2.422,0,2.13.044,2.13-.1C3.147,19.85,2.83,17.887,4.641,16.039Z",
  transform: "translate(0 -8.313)",
  fill: "#fff"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_306",
  "data-name": "Path 306",
  d: "M13.267,15.5a5.135,5.135,0,0,0-3.961.937c-1.9,1.52-1.532,3.566-1.532,6.069a1.213,1.213,0,0,0,1.211,1.211c7.3,0,7.591.236,8.024-.723.142-.324.1-.221.1-3.323A4.193,4.193,0,0,0,13.267,15.5Z",
  transform: "translate(-3.59 -8.292)",
  fill: "#fff"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_307",
  "data-name": "Path 307",
  d: "M26.644,15.506a3.074,3.074,0,0,0-2.293.532c1.8,1.835,1.494,3.664,1.494,6.488,0,.149-.242.1,2.094.1a1.053,1.053,0,0,0,1.054-1.049V17.841A2.344,2.344,0,0,0,26.644,15.506Z",
  transform: "translate(-11.285 -8.313)",
  fill: "#fff"
});

var SvgSpilklub = function SvgSpilklub(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "customer",
    width: 17.707,
    height: 15.451,
    viewBox: "0 0 17.707 15.451",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSpilklub, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spilklub.cbc6d202.svg";
export { ForwardRef as ReactComponent };